import { Button, Form, Input, Skeleton, Switch } from "antd";
import axios from "axios";
import React from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "./open-vendor.module.css";

const OpenVendorForm = () => {
  const [form] = Form.useForm();
  const [financialDetails, setFinancialDetails] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [done, setDone] = React.useState(false);
  const { id, org, orgname } = useParams();
  const [orgDetails, setOrgDetails] = React.useState(null);
  
  const onFormFinish = (values) => {
    const filteredFields = Object.fromEntries(
      Object.entries(values).filter(([key, value]) => value !== undefined)
    );
    setSubmitting(true);

    axios.post("apiV1/vendor-onbaording/", {
      ...filteredFields,
      otp: id,
      organisation: org,
    }).then(response => {
      if (response.status > 300) {
        toast.error("Something went wrong... Please try again, or verify the shared URL.");
      } else {
        setDone(true);
      }
    });
  };

  React.useEffect(() => {
    axios.get(`apiV1/public-organisation/?organisation=${encodeURIComponent(orgname)}`)
      .then(org => {
        setOrgDetails({
          ...org.data,
          organisation_logo: `https://mysite-powo-pdfs.s3.ap-south-1.amazonaws.com/media/${org.data.organisation_logo}`,
        });
      });
  }, [orgname]);

  const getContent = () => {
    if (done) {
      return (
        <section className={styles.done}>
          <h1>Thank you!</h1>
          <p>Your application has been submitted. The organisation will get back to you shortly.</p>
        </section>
      );
    }

    return (
      <Form
        layout="vertical"
        className={styles.form}
        form={form}
        onFinish={onFormFinish}
        disabled={submitting}
      >
        <div className={styles.title}>Vendor Form</div>
        <Form.Item
          label="Vendor Business Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Vendor Business Name is required",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Contact Person Name" name="contact_person"
        rules={
          [
            {
              pattern: /^[A-Za-z]+[A-Za-z ]*$/,
              message: "Enter valid person name",
            },
          ]
        }>
          <Input />
        </Form.Item>
        <Form.Item
          label="Phone Number"
          name="contact"
          rules={[
            {
              required: true,
              pattern: /^[1-9]\d{9}$/gi,
              message: "Phone Number is required",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              pattern:
                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
              message: "Email is required",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Address" name="address">
          <Input />
        </Form.Item>
        <Form.Item
          label="Pincode"
          name="pincode"
          rules={[
            {
              required: true,
              pattern: /^[1-9]\d{5}$/gi,

              message: "Enter a valid pincode",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <div className={styles.switchContainer}>
          <span className={styles.financialDetailsLabel}>Financial Details</span>
          <Switch value={financialDetails} onChange={setFinancialDetails} />
        </div>
        {financialDetails && (
          <section className={styles.grid}>
            <Form.Item label="Bank Account Number" name="bank_account_number">
              <Input />
            </Form.Item>
            <Form.Item label="Account Holder Name" name="bank_account_holder">
              <Input />
            </Form.Item>
            <Form.Item label="IFSC Code" name="bank_ifsc">
              <Input />
            </Form.Item>
            <Form.Item label="Billing Address" name="billing_address">
              <Input />
            </Form.Item>
            <Form.Item label="GST Number" name="gst">
              <Input />
            </Form.Item>
            <Form.Item label="PAN Number" name="pan_number">
              <Input />
            </Form.Item>
          </section>
        )}
        <section className={styles.actionContainer}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </section>
      </Form>
    )
  }

  return (
    <section className={styles.container}>
      {orgDetails ? (
        <section className={styles.orgDetails}>
          <img src={orgDetails.organisation_logo} alt="Organisation Logo" className={styles.orgLogo} />
          <section className={styles.orgDetailsText}>
            <h1>{orgDetails.name}</h1>
            <p>{orgDetails.address}</p>
          </section>
        </section>
      ) : (
        <Skeleton active />
      )}
      {getContent()}
    </section>
  );
};

export { OpenVendorForm };
